<template>
    <div class="register">
        <div class="container mt-5">
            <div class="ui segment pl-0 pr-0">
                <h3 class="ui header large-lg medium-md small black pt-2 pb-1 px-lg-5 px-md-3 px-2 mb-0 text-center">{{$t('SignIn')}} / {{$t('Register')}}
                    <div class="ui secondary pointing menu d-flex d-md-none mb-4 js-tab">
                        <router-link :to="'/login'" class="ui text medium item px-4  ml-auto" data-tab="login">{{$t('SignIn')}}</router-link>
                        <router-link :to="'/register'" class="ui text medium item px-4 mr-auto active" data-tab="register">{{$t('Register')}}</router-link>
                    </div>
                    <div class="position-relative">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-12">
                                <form class="pt-3 pl-3 pr-3 pb-lg-3 pb-sm-0">
                                    <!-- <h3 class="ui header semibold medium-lg small-md mini text-center color theme d-md-block">{{$t('Register')}}</h3> -->
                                    <div class>
                                        <div class="ui labeled input col-12">
                                            <div class="ui basic label">
                                                <div class="circular ui icon button grey m-0 p-2"><i class="ui icon envelope open color white"></i></div>
                                            </div>
                                            <input v-model="email" class type="email" :placeholder="$t('inEmail')">
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <div class="ui labeled input col-12">
                                            <div class="ui basic label">
                                                <div class="circular ui icon button grey m-0 p-2"><i class="ui icon lock color white"></i></div>
                                            </div>
                                            <input v-model="password" type="password" :placeholder="$t('inPassword')">
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <div class="ui labeled input col-12">
                                            <div class="ui basic label">
                                                <div class="circular ui icon button grey m-0 p-2"><i class="ui icon lock color white"></i></div>
                                            </div>
                                            <input v-model="confirmPassword" type="password" :placeholder="$t('inPasswordConfirm')">
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button @click.prevent="registerFunction" class="ui button theme text large col-12 mt-3 py-md-3 py-2">{{$t('Register')}}</button>
                                    </div>
                                </form>
                            </div>
                            <div class="d-block d-md-none col-12">
                                <div class="ui horizontal divider">{{$t('OR')}}</div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="pl-4 pr-4 pt-lg-4 pt-sm-0">
                                    <div class="row justify-content-center">
                                        <div class="col-lg-8 col-12">
                                            <button id="btnGoogle" @click.prevent="$parent.googleLogin" class="ui button text large col-12 py-md-3 py-2">
                                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 48 48" class="abcRioButtonSvg">
                                                                <g>
                                                                    <rect x="0" y="0" rx="10" ry="10" width="48" height="48"
                                                                    style="fill:#FFF;" />
                                                                    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                                                    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                                                    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                                                    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                                                </g>
                                                            </svg>
                                                        &nbsp; &nbsp; &nbsp;Google</button>
                                            <button @click.prevent="$parent.facebookLogin" class="ui button facebook text large col-12 mt-3 py-md-3 py-2">
                                            <i class="facebook icon"></i> Facebook</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ui vertical divider d-none d-md-block">{{$t('OR')}}</div>
                    </div>
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
import Message from '@/components/popup/Message'
export default {
  name: 'register',
  components: {
   Message
  },
  data(){
    return {
      email: '',
      password: '',
      confirmPassword: '',
      loading : true,
      showMessage: false,
    }
  },
  methods:{
      registerFunction(){
        this.$parent.message.title = this.$t('Register') 
        this.loading = true
        if(this.password !== this.confirmPassword){
            let message = 'รหัสผ่านไม่ตรงกัน'
            this.$parent.message.message = message
            this.$parent.showMessage = !this.showMessage
            return
        }
        this.$http.post('register',{email: this.email,password:this.password})
        .then(response => {
            let user = response.data.data
            localStorage.setItem('_auth', user.token)
            this.$parent.logged = true
            this.$router.push('/profile')
        })
        .catch(error => {
            if(!error.response){
                return
            }
            let message = error.response.data.errors.message
            let snakeCase = error.response.data.errors.snakeCase
            switch (snakeCase) {
                case 'the_email_field_is_required.':
                    message = this.$t('rqEmail')
                    // error.response.data.errors
                    break;
                case 'the_email_field_is_required.':
                    message = this.$t('rqEmail')
                    break;
                case 'the_password_field_is_required.':
                    message = this.$t('rqPass')
                    break;
                case 'the_password_must_be_at_least4_characters.':
                    message = this.$t('rqPassMin',{num:4})
                    break;
                case 'the_email_has_already_been_taken.':
                    message = this.$t('rqEmailUnique')
                    break;
            }
            this.$parent.message.message = message
            this.$parent.showMessage = !this.showMessage
        })
        .finally(() => this.loading = false)
      }
  }
}
</script>
<style lang="scss">
.modal-dialog{
        top: 100px !important;
    }
    #btnGoogle{
        background-color: #4285f4;
        border: none;
        color: #fff;
        span{
            position: relative;
            background-color: #fff;
            width: 20px;
            height: 20px;
        }
    }
</style>
